import { Typography } from "@material-ui/core"

export const TemplateMissing=({metaData})=>{
    return<>
    <Typography><strong>Step 1:</strong> Go to the <strong>Settings</strong> menu.</Typography>
            <Typography><strong>Step 2:</strong> Select the Email Menu.</Typography>
            <Typography><strong>Step 3:</strong> Open the <strong>{getOpenTabName(metaData.Id)}</strong> tab.</Typography>
            <Typography><strong>Step 4:</strong> Verify all version of templates are there if not, write your template and click save.</Typography>

            </>
}

const getOpenTabName = (key) => {
  switch (key) {
    // Email Reminders
    case "FirstReminder":
    case "SecondReminder":
    case "ThirdReminder":
      return "Email Reminder Settings";

    // Post Reminders
    case "FirstPostReminder":
    case "SecondPostReminder":
    case "ThirdPostReminder":
      return "Post Reminder Settings";

    // SMS Reminders
    case "FirstSMSReminder":
    case "SecondSMSReminder":
    case "ThirdSMSReminder":
      return "SMS Reminder Settings";

    // Recovery Procedure
    case "RecoveryProcedure":
    case "FirstPerson":
    case "SecondPerson":
    case "ThirdPerson":
      return "Recovery Procedure Settings";

    // Call Reminder
    case "CallReminder":
      return "Call Reminder Settings";
    default:
      return "Settings";
  }
};